// N11 Ürün Satışa Aç penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'inventory.n11ProductCreate';

export const inventoryN11ProductCreateGuide = (t: TFunction): GuideContent => ({
  layout: 'dialog',
  title: t(`${G}.title`, 'N11\'de ürün nasıl satışa açılır?'),
  intro: t(`${G}.intro`, 'Bu pencere, N11 katalogunda bulduğunuz ürünü kendi fiyat ve stok bilgilerinizle N11 mağazanızda satışa açar. Bilgiler yalnız N11\'e gönderilir; GTS\'teki stok kartınız ve stok miktarınız bu pencereden değişmez.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık ve seçilen ürün'),
    body: t(`${G}.regions.body`, 'Satış bilgileri'),
    footer: t(`${G}.regions.footer`, 'Temizle / İptal / Satışa Aç'),
  },
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Seçilen ürünü kontrol edin'),
      text: t(`${G}.s1.text`, 'Üstteki kutuda "Seçilen Ürün" adı, Katalog ID ve kategori görünür. Ürün N11 katalogundaki bu kayda bağlanarak açılır.'),
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Stok kodu ve ürün bilgileri'),
      text: t(`${G}.s2.text`, '"Stok Kodu *" zorunludur; ürünü N11\'de sizin mağazanızda tanımlar. "Ürün Ana ID" boş bırakılırsa otomatik oluşturulur. "Açıklama" boş bırakılırsa katalog açıklaması kullanılır. "Hazırlık Süresi (Gün)" siparişi kargoya verme sürenizdir (varsayılan 2).'),
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Satış ve liste fiyatı'),
      text: t(`${G}.s3.text`, '"Satış Fiyatı (TL) *" ve "Liste Fiyatı (TL) *" zorunludur ve sıfırdan büyük olmalıdır.'),
      tips: [
        t(`${G}.s3.tip1`, 'Satış fiyatı liste fiyatından büyük olamaz; büyükse gönderim yapılmaz ve uyarı çıkar.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s4.title`, '4. Stok, KDV ve satın alma sınırı'),
      text: t(`${G}.s4.text`, '"Stok Miktarı", N11\'de satışa açılacak adettir (varsayılan 1). "KDV Oranı (%)" listeden seçilir (%0, %1, %8, %18, %20). "Max Satın Alma", bir müşterinin tek seferde alabileceği en fazla adettir (varsayılan 5).'),
    },
    {
      region: 'body',
      title: t(`${G}.s5.title`, '5. Kargo şablonu'),
      text: t(`${G}.s5.text`, '"Kargo Şablonu" alanına N11 satıcı panelinizdeki kargo şablonunun adını aynen yazın. Varsayılan değer BAREM\'dir.'),
    },
    {
      region: 'footer',
      title: t(`${G}.s6.title`, '6. Ürünü satışa açın'),
      text: t(`${G}.s6.text`, '"Ürünü Satışa Aç" düğmesi stok kodu ve iki fiyat dolunca açılır. Gönderimden sonra Task ID ve durum yazar; ürün N11\'de işleme alınır, sonucunu N11 satıcı panelinden kontrol edin. "Temizle" formu sıfırlar, "İptal" pencereyi kapatır.'),
    },
  ],
});
